export const TPA_HANDLER_EMPTY_RESPONSE = Symbol('TPA_HANDLER_EMPTY_RESPONSE')

export const PERMITTED_FULL_SCREEN_TPAS_IN_MOBILE = {
	WIX_CHAT: '14517e1a-3ff0-af98-408e-2bd6953c36a2',
	WIX_RESTAURANTS: '13e8d036-5516-6104-b456-c8466db39542',
}

export const LINK_TYPES = {
	PAGE_LINK: 'PageLink',
	EXTERNAL_LINK: 'ExternalLink',
	ANCHOR_LINK: 'AnchorLink',
	LOGIN_TO_WIX_LINK: 'LoginToWixLink',
	EMAIL_LINK: 'EmailLink',
	PHONE_LINK: 'PhoneLink',
	WHATSAPP_LINK: 'WhatsAppLink',
	DOCUMENT_LINK: 'DocumentLink',
	SWITCH_MOBILE_VIEW_MODE: 'SwitchMobileViewMode',
	DYNAMIC_PAGE_LINK: 'DynamicPageLink',
	ADDRESS_LINK: 'AddressLink',
	MENU_HEADER: 'MenuHeader',
	TPA_PAGE_LINK: 'TpaPageLink',
}
